module.exports = __webpack_public_path__ + "img/progress_064.e3bce74e.png";